import React, { useState, useRef, useEffect } from "react";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import CurrencyInput from 'react-currency-input-field';
import ContentLoader from "react-content-loader";
import axios from 'axios';
import "react-datepicker/dist/react-datepicker.css";

import AddPaymentScheduleService from "../../../services/contract/paymentSchedule/addPaymentScheduleService";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import PaymentScheduleList from "../../../components/paymentScheduleList";

function AddPaymentSchedules({ date, contract, contractterm, payment_rule, payment_frequency, contract_date }) {

    const [payment_type, setPayment_type] = useState("Rent");
    const [no_of_payments, setNo_of_payments] = useState(null);
    const [amount, setAmount] = useState(null);
    const [frequency, setFrequency] = useState("Monthly");
    const [start_date, setStart_date] = useState("");
    const [end_date, setEnd_date] = useState(null);
    const [successful, setSuccessful] = useState(false);
    const [loading, setLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showpaymentschedule, setShowPaymentSchedule] = useState(false)

    const checkBtn = useRef();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const form = useRef();
    const id = contract
    const startDate = date
    const contract_term = contractterm
    const paymentfrequency = payment_frequency
    const contractdate = contract_date
    const [feedefination, setFeeDefination] = useState([])
    const filterfeenature = feedefination.filter((value) => value.fee_name === payment_type)

    const validateNumberOfPayments = (value) => {
        const frequencyMapping = {
            Monthly: { months: 1 },
            Quarterly: { months: 3 },
            "Semi-annual": { months: 6 },
            Annual: { months: 12 }
        };
        const cycleDelta = frequencyMapping[paymentfrequency]
        if (payment_type === "Rent") {

            if (paymentfrequency === "Quarterly" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Quarterly frequency.`;
            }
            if (paymentfrequency === "Monthly" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Monthly frequency.`;
            }
            if (paymentfrequency === "Semi-annual" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Semi-annual frequency.`;
            }
            if (paymentfrequency === "Annual" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Annual frequency.`;
            }
            return true; // Return true for no error
        };
    }

    useEffect(() => {
        if (payment_type === "Rent") {
            setStart_date(startDate);
        }
        else {
            setStart_date(contractdate); // Reset start date to the original value

        }
        setFrequency(paymentfrequency)
        const frequencyMapping = {
            Monthly: { months: 1 },
            Quarterly: { months: 3 },
            "Semi-annual": { months: 6 },
            Annual: { months: 12 }
        };
        const cycleDelta = frequencyMapping[paymentfrequency]
        if (filterfeenature.length !== 0) {

            if (filterfeenature[0].fee_nature === "One Time") {
                setNo_of_payments(1)
            }
            else {
                setNo_of_payments(contract_term / cycleDelta.months);
            }
        }
        if (payment_type === "Rent") {
            setNo_of_payments(contract_term / cycleDelta.months);
            reset({
                nopayyments: no_of_payments
            })
        }
        reset({
            startdate: startDate,

        })
    }, [payment_type])

    const handelStart_Date = (value) => {
        setStart_date(value)
        reset({
            startdate: value
        })
    }
    useEffect(() => {
        FeeDefination()
    }, [])

    useEffect(() => {
        const frequencyMapping = {
            Monthly: { months: 1 },
            Quarterly: { months: 3 },
            "Semi-annual": { months: 6 },
            Annual: { months: 12 }
        };
        const cycleDelta = frequencyMapping[paymentfrequency]
        if (filterfeenature.length !== 0) {

            if (filterfeenature[0].fee_nature === "One Time") {
                setenddate(contract_term / cycleDelta.months)
            }
            else {
                setenddate(no_of_payments);
            }
        }
        if (payment_type === "Rent") {
            setenddate(no_of_payments);
        }
    }, [no_of_payments, paymentfrequency, start_date])

    const handleiir = () => {
        let url = API + "contracts/contractiir/?";
        url += 'id=' + id
        axios.get(url, { headers: authHeader() })
            .then(response => console.log("data", response.data))
    }
    const FeeDefination = () => {
        setIsLoading(true)
        let url = API + "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes"
        axios.get(url, { headers: authHeader() }).then(
            response => {
                setFeeDefination(response.data);
                // setTimeout(() => {
                    setIsLoading(false)
                // }, 1000);
            }
        )
    }

    const setenddate = (no_of_payments) => {
        if (startDate === "") {
            return false;
        }

        var noofdays = 0;
        if (payment_type === "Recurring Fee" || payment_type === "One-Time Fee") {
            var dt = new Date(contractdate);
        }
        else {
            var dt = new Date(start_date);
        }
        var newdate = new Date(dt);
        let paymentStartDate, paymentEndDate;
      
        paymentEndDate = new Date(newdate);
        paymentEndDate.setMonth(paymentEndDate.getMonth() + parseInt(contract_term));
        paymentEndDate.setDate(paymentEndDate.getDate() - 1);
        setEnd_date(paymentEndDate)
        // if (paymentfrequency === 'Weekly') {
        //     noofdays = no_of_payments * 7;
        //     newdate.setDate(newdate.getDate() + (noofdays - 1));
        //     var dd = newdate.getDate();
        //     var mm = newdate.getMonth() + 1;
        //     var y = newdate.getFullYear();
        //     var someFormattedDate = y + '-' + mm + '-' + dd;
        //     setEnd_date(someFormattedDate);
        // } else if (paymentfrequency === 'Monthly') {
        //     noofdays = no_of_payments * 1;
        //     newdate.setDate(newdate.getDate() - 1);
        //     var dd = newdate.getDate();
        //     var mm = newdate.getMonth() + 1;
        //     var y = newdate.getFullYear();
        //     var someFormattedDate = y + '-' + mm + '-' + dd;
        //     setEnd_date(someFormattedDate);
        // } else if (paymentfrequency === 'Quarterly') {
        //     newdate.setDate(newdate.getDate() - 1);
        //     var dd = newdate.getDate();
        //     var mm = newdate.getMonth() + 1;
        //     var y = newdate.getFullYear();
        //     var someFormattedDate = y + '-' + mm + '-' + dd;
        //     setEnd_date(someFormattedDate);
        // } else if (paymentfrequency === 'Semi-annual') {
        //     newdate.setDate(newdate.getDate() - 1);
        //     var dd = newdate.getDate();
        //     var mm = newdate.getMonth() + 1;
        //     var y = newdate.getFullYear();
        //     var someFormattedDate = y + '-' + mm + '-' + dd;
        //     setEnd_date(someFormattedDate);
        // } else if (paymentfrequency === 'Annual') {
        //     newdate.setDate(newdate.getDate() - 1);
        //     var dd = newdate.getDate();
        //     var mm = newdate.getMonth() + 1;
        //     var y = newdate.getFullYear();
        //     var someFormattedDate = y + '-' + mm + '-' + dd;
        //     setEnd_date(someFormattedDate);
        // } else {
        //     noofdays = 0;
        // }
    }

    const handleCancel = () => {
        setShowPaymentSchedule(true)
    }

    const [disable, setDisable] = useState(false)
    const handleRegister = () => {
        setSuccessful(false);
        setLoading(true)
        setDisable(true)
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            AddPaymentScheduleService.addPaymentSchedule(
                id,
                no_of_payments,
                payment_type,
                amount,
                frequency,
                Helper.DatePicker(start_date),
                Helper.DatePicker(end_date),
            ).then(
                (response) => {
                    if (response.data.success) {
                        setSuccessful(true);
                        setLoading(false)
                        setTimeout(() => {
                            handleiir()
                            setDisable(false)
                            setShowPaymentSchedule(true)
                        }, 2000)
                        toast.success(`${response.data.response}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                    }
                    else {
                        toast.error(`${response.data.error}`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        setSuccessful(false);
                        setDisable(false)
                    }
                },
            )
        }
    }

    return (
        <>
            <div className="">
                {
                    showpaymentschedule === false ?
                        <>
                            <ToastContainer />
                            <div className="header mb-2 pt-3">
                                <h5 className="modal-title text-left" style={{color :'#000000'}}>{t("Add Payment Schedules")}</h5>
                            </div>
                            <div className='card '>
                                <div className="card-body">
                                    <div className="col-xl-12 ">
                                        {isLoading !== true ?
                                            <Form role="form text-left"
                                                onSubmit={handleSubmit(handleRegister)}
                                                ref={form}
                                                action="."
                                                method="POST"
                                                id="addPartyContactForm" >
                                                {(
                                                    <>
                                                        <div className="form-group row">
                                                            <div className="col-xl-6">
                                                                <label className="col-lg-4 col-form-label text-left required">{t("No of Payments")} <Tooltip content={t("NoofPayments_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <input
                                                                    type="text"
                                                                    id="payment_amount"
                                                                    className="form-control"
                                                                    name="nopayyments"
                                                                    value={no_of_payments}
                                                                    disabled={filterfeenature.length !== 0 ? filterfeenature[0].fee_nature === "One Time" : "" ? true : false}
                                                                    {...register("nopayyments", {
                                                                        onChange: (e) => setNo_of_payments(e.target.value), required: payment_type === "Rent" ? true : false,
                                                                        validate: (value) => validateNumberOfPayments(value) // Use custom validation
                                                                    })}
                                                                />
                                                                <div className="invalid-feedback">
                                                                    {errors.nopayyments?.type === 'required' && "Number of Payments  is required"}
                                                                    {errors.nopayyments?.message} {/* Display custom error message */}
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6">
                                                                <label className="col-lg-4 col-form-label text-left required">{t("Payment Amount")} <Tooltip content={t("PaymentAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <CurrencyInput
                                                                    className="form-control"
                                                                    {...register("paymentamount", { required: true })}
                                                                    onValueChange={(value) => setAmount(value)}
                                                                    name="paymentamount"
                                                                    id="input-example"
                                                                    allowDecimals="false"
                                                                    disableAbbreviations
                                                                />
                                                                <div className="invalid-feedback">
                                                                    {errors.paymentamount?.type === 'required' && "Payment Amount  is required"}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="form-group row">
                                                                <div className="col-xl-6">
                                                                    <label className="col-lg-6 col-form-label text-left required">{t("Payment Type")} <Tooltip content={t("PaymentType_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                    <select
                                                                        id="frequency"
                                                                        className="form-control"
                                                                        name="paymenttype"
                                                                        value={payment_type}
                                                                        {...register("paymenttype", { onChange: (e) => { setPayment_type(e.target.value) }, required: true })}
                                                                    >
                                                                        <option value="">{("Select Payment Type")}</option>
                                                                        {/* <option value="Rent">{t("Rent")}</option> */}
                                                                        {
                                                                            feedefination.map((key) => (
                                                                                <option key={key.id} value={key.fee_name}>{key.fee_name}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <div className="invalid-feedback">
                                                                        {errors.paymenttype && "Payment Type is required"}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-12">
                                                            <div className="form-group row">
                                                                <div className="col-xl-6">
                                                                    <label className="col-lg-6 col-form-label text-left required">{t('Start Date')} <Tooltip content={t("StartDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                    <DatePicker
                                                                        className="form-control datepick"
                                                                        {...register("startdate", { required: true })}
                                                                        selected={start_date ? new Date(start_date) : new Date()}
                                                                        onChange={(e) => handelStart_Date(e)}
                                                                        name="startdate"
                                                                        placeholderText={"mm/dd/yyyy"}
                                                                        showYearDropdown // year show and scrolldown alos
                                                                        scrollableYearDropdown
                                                                        showMonthDropdown
                                                                        disabled
                                                                        dropdownMode="select"
                                                                    />
                                                                    <div className="invalid-feedback">
                                                                        {errors.startdate && "Start Date  is required"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6">
                                                                    <label className="col-lg-6 col-form-label text-left">{t("End Date")} <Tooltip content={t("EndDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                    <input

                                                                        disabled
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="payment_enddate"
                                                                        id="payment_enddate"
                                                                        value={end_date ? Helper.Dateview(end_date) : ""}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <input type="hidden" id="paymentId" />
                                                        <div className="text-left py-3">
                                                            <button type="button" className="payment-cancel btn btn-secondary btn-md" onClick={handleCancel}>{t("Cancel")}</button>&nbsp;&nbsp;
                                                            <button type="submit" disabled={disable} className="updatePayment border-0 btn btn-primary btn-gradient-primary btn-md">
                                                                {
                                                                    loading === false ? (
                                                                        t('Save')
                                                                    ) : (
                                                                        <ButtonLoading />
                                                                    )
                                                                }
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                                <CheckButton style={{ display: "none" }} ref={checkBtn} />
                                            </Form> :
                                            <ContentLoader
                                                viewBox="0 0 1000 550"
                                                backgroundColor="rgba(0,0,0,0.06)"
                                                foregroundColor="rgba(0,0,0,0.12)"
                                            >
                                                <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                                                <circle cx="879" cy="123" r="11" />
                                                <circle cx="914" cy="123" r="11" />
                                                <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                                                <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                                                <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                                                <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                                                <circle cx="880" cy="184" r="11" />
                                                <circle cx="915" cy="184" r="11" />
                                                <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                                                <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                                                <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                                                <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                                                <circle cx="881" cy="242" r="11" />
                                                <circle cx="916" cy="242" r="11" />
                                                <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                                                <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                                                <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                                                <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                                                <circle cx="882" cy="303" r="11" />
                                                <circle cx="917" cy="303" r="11" />
                                                <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                                                <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                                                <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                                                <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                                                <circle cx="881" cy="363" r="11" />
                                                <circle cx="916" cy="363" r="11" />
                                                <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                                                <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                                                <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                                                <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                                                <circle cx="882" cy="424" r="11" />
                                                <circle cx="917" cy="424" r="11" />
                                                <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                                                <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                                                <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                                                <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                                                <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                                                <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                                                <circle cx="882" cy="484" r="11" />
                                                <circle cx="917" cy="484" r="11" />
                                                <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                                                <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                                                <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                                                <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                                                <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                                                <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                                                <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                                                <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                                                <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                                                <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                                            </ContentLoader>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <PaymentScheduleList id={{ contract_id: id, contract_start_date: contract_date, contract_term: contract_term }} />

                }
            </div>
        </>

    )
}

export default AddPaymentSchedules
